import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutAlphavision from "./sections/AboutAlphavision";
import OurSolutions from "./sections/OurSolutions";
import IndustriesServed from "./sections/IndustriesServed";
import ContactInfo from "./sections/ContactInfo";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutAlphavision />
      <OurSolutions />
      <IndustriesServed />
      <ContactInfo />
      <Footer />
    </div>;
}